module.exports = __webpack_public_path__ + "static/media/image_bestcare.d474d756.png";